import { render, staticRenderFns } from "./AddIVR.vue?vue&type=template&id=36aeebd3&"
import script from "./AddIVR.vue?vue&type=script&lang=js&"
export * from "./AddIVR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports